import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { getTokenSetup } from '../../store/adminSelector';
import { getNextMapAction } from '../../store/presentationSelector';
import { fetchTokenSetup, fetchInitialSetup } from '../../store/adminActions';
import { setMapLoaded } from '../../store/presentationActions';
import { initialiseClientMap } from '../../helpers/mapHelper';
import { executeMapAction } from '../../helpers/mapActions';
import { getTrailLink } from '../../helpers/commonHelper';

let mapInstance;

function ClientMap(props) {
    const {
        adminMode,
        tokenSetup,
        mapAction,
        initSetup,
        mapLoaded,
    } = props;
    let mapContainer;
    const history = useHistory();
    // Token dependent
    useEffect(() => {
        if (tokenSetup) {
            initialiseClientMap(
                mapContainer,
                mapInstance,
                tokenSetup,
                () => {
                    mapLoaded();
                },
                (uuid) => {
                    history.push(getTrailLink(uuid));
                },
            );
        } else {
            initSetup();
        }
    }, [tokenSetup, mapContainer, initSetup, adminMode, mapLoaded, history]);
    // Action dependent
    useEffect(() => {
        if (!mapAction) {
            return;
        }
        executeMapAction(mapAction);
    }, [mapAction]);
    return <div className="map-container" id="client-map" ref={(el) => (mapContainer = el)} />;
}

const mapStateToProps = (state) => {
    return {
        tokenSetup: getTokenSetup(state),
        mapAction: getNextMapAction(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        initSetup: () => {
            dispatch(fetchTokenSetup());
            dispatch(fetchInitialSetup());
        },
        mapLoaded: () => dispatch(setMapLoaded()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientMap);
